import { render, staticRenderFns } from "./CargaHorariaTeorica.vue?vue&type=template&id=2b8e5498&scoped=true"
import script from "./CargaHorariaTeorica.vue?vue&type=script&lang=js"
export * from "./CargaHorariaTeorica.vue?vue&type=script&lang=js"
import style0 from "./CargaHorariaTeorica.vue?vue&type=style&index=0&id=2b8e5498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e5498",
  null
  
)

export default component.exports